import { Link } from "react-router-dom";
import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import i18n from "../../i18n/i18n";

const TeamBuildingActivityListItem = ({ activity }) => {
  const handleImageLoad = () => {
    setIsLoading(false);
  };
  const [isLoading, setIsLoading] = useState(true);
  const detailUrl = `/team-building-activities/${activity.slug || activity.id}`;

  // Get the main image URL (first image or image_url)
  const imageUrl =
    activity.images && activity.images.length > 0
      ? activity.images[0].url
      : activity.image_url || "";

  return (
    <div className="col-xl-3 col-lg-4 col-md-4 d-flex">
      {/* Single Activity Start */}
      <div className="single-courses w-100">
        <div className="courses-images">
          {isLoading && <Spinner animation="border" variant="primary" />}
          <Link to={detailUrl}>
            <img
              src={imageUrl}
              alt={activity.title}
              onLoad={handleImageLoad}
              style={{ visibility: isLoading ? "none" : "visible" }}
            />
          </Link>
        </div>
        <div className="courses-content">
          <h4 className="title" style={{ marginTop: "-2px" }}>
            <Link to={detailUrl}>{activity.title}</Link>
          </h4>
          {activity.description && (
            <p
              style={{
                fontSize: "14px",
                color: "#666",
                marginTop: "8px",
                marginBottom: "16px",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                lineHeight: "1.5",
              }}
            >
              {activity.description}
            </p>
          )}
          <div className="courses-price-review bg-primary text-white font-weight-bold">
            <div className="courses-price" style={{ fontWeight: "bold", textAlign: "center" }}>
              <Link to={detailUrl} style={{ color: "white", textDecoration: "none" }}>
                View Details
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Single Activity End */}
    </div>
  );
};

export default TeamBuildingActivityListItem;

